import { useCallback } from 'react';
import type { ReadinessEventBody, ReadinessClientEventName } from '@formency/shared';
import { api } from '../client';

/**
 * Fire-and-forget client telemetry helper for readiness events.
 *
 * The HTTP request is deliberately not awaited — callers don't want to block
 * UI on a telemetry write, and the readiness pipeline tolerates lost events.
 * Errors are swallowed silently (client-side logging is fine; we don't want
 * to spam console errors for transient telemetry failures).
 *
 * See docs/fatigue-score/README.md §12.
 */
export function useReadinessEvent(): (
  event: ReadinessClientEventName,
  props?: Omit<ReadinessEventBody, 'event'>
) => void {
  return useCallback((event, props = {}) => {
    const body: ReadinessEventBody = { event, ...props };
    void api.post('/me/readiness/events', body).catch(() => {
      /* swallow — telemetry must never break the UI */
    });
  }, []);
}
